import * as React from 'react';
const TreeSelectContext = React.createContext(null);
export default TreeSelectContext;
